import { render } from "./NotificationsButton.vue?vue&type=template&id=d5c73712&scoped=true"
import script from "./NotificationsButton.vue?vue&type=script&lang=js"
export * from "./NotificationsButton.vue?vue&type=script&lang=js"

import "./NotificationsButton.vue?vue&type=style&index=0&id=d5c73712&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5c73712"]])

export default __exports__